<template>
    <tr>
        <td>{{ platform }}</td>
        <td>{{ store }}</td>
        <td>
            <input type="text" class="form-control" style="width: 140px; background-color: #e9ecef;" v-model="versionNum"/>
        </td>
        <td>
            <input type="text" class="form-control" style="width: 100%; background-color: #e9ecef;" v-model="url"/>
        </td>
        <td>{{ date | formatDate }}</td>
        <td>
            <button
                class="btn btn-primary"
                @click.prevent="save"
            >{{ translate.save}}
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    props: ['item', 'translate'],
    data() {
        return {
            id: this.item.id,
            platform: this.item.platform?.name,
            store: this.item.store?.name,
            versionNum: this.item.version,
            url: this.item.url,
            date: this.item.updated_at,

            isSaveSuccess: null,
        }
    },
    mounted() {
    },
    methods: {
        save(id) {
            if (!this.versionNum) {
                return false;
            }

            axios
                .post(`/v1/app-versions-old/${this.id}`, {'version': this.versionNum, 'url': this.url})
                .then(response => (this.$emit('success', 'Версия приложения успешно обновлена')));
        },
    }
}
</script>
